import BreadcrumbLayout from 'components/layout/BreadcrumbLayout';
import { useTranslation } from 'react-i18next';
import { FullScreenSpinner, FullScreenError } from 'components/FullScreen';
import AddToTeamForm from 'pages/AddToTeam/AddToTeamForm';
import { useLocation, useNavigate } from 'react-router';
import { InviteeResponse, useGetGroupByOrganisation } from 'api';
import { useAuth } from 'contexts/AuthContext';

export const AddToTeamFromEvents = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { state } = useLocation();

  const { user } = useAuth();

  const { inviteesToAdd, organisation, event } = state;

  const canViewGroups =
    user?.permissions.Organisation_Group_ReadAll &&
    user?.permissions.Organisation_Group_ReadAll !== 'None';

  const {
    data: groupData,
    isLoading,
    isError,
  } = useGetGroupByOrganisation(organisation?.id || '', {
    enabled: canViewGroups,
  });
  if (isLoading) {
    return <FullScreenSpinner />;
  }
  if (isError) {
    return (
      <FullScreenError message={t('ui.event-management.teams.error-loading')} />
    );
  }

  if (inviteesToAdd.length === 0 || !event || !organisation) {
    navigate('/experiences');
  }

  return (
    <BreadcrumbLayout
      titleKey="ui.event-management.evaluator-links.teams.add-to-team"
      activeTextKey="ui.event-management.add-to-team.button"
      crumbs={{
        '/': t('ui.event-management.events.nav.home'),
        '/experiences': t('ui.event-management.events.title'),
        [`/experiences/${event.id}`]: event.name,
        [`/experiences/${event.id}/learners`]: t(
          'ui.event-management.events.summary.manage-learners',
        ),
      }}
      headingKey="ui.event-management.evaluator-links.teams.add-to-team"
    >
      <AddToTeamForm
        learners={inviteesToAdd.map((learner: InviteeResponse) => {
          return {
            fullName: learner.fullName,
            id: learner?.learner?.id || '',
            emailAddress: learner.email,
          };
        })}
        group={groupData ?? null}
        organisation={organisation}
      />
    </BreadcrumbLayout>
  );
};
